import { formatCurrency } from '@/lib/format';
import type { SalaryCalculation, StaffSalary } from '@/types/payroll';

/** "40% of Basic", "₹1,600", or a dash when nothing is set. */
export function describeValue(calculation: SalaryCalculation, value: string | null): string {
  if (value === null) return '—';
  return calculation === 'PERCENT_OF_BASIC' ? `${Number(value)}% of Basic` : formatCurrency(value);
}

/**
 * "+9.63%" for a rise, "−2%" for a cut, or null when there was nothing to
 * compare against. The server works the figure out; this only prints it.
 */
export function describeIncrement(percent: string | null): string | null {
  if (percent === null) return null;
  const value = Number(percent);
  return value >= 0 ? `+${value}%` : `−${Math.abs(value)}%`;
}

/**
 * The newest increment or promotion already in force — the same rule as the
 * staff list's Last Increment column (`salarySummariesFor`). Shared by the
 * profile's Overview card and its Payroll tab, so the two always name the same one.
 *
 * `history` is newest first; `today` is the institute's own `YYYY-MM-DD`.
 */
export function lastIncrementOf(history: StaffSalary[], today: string): StaffSalary | null {
  return (
    history.find(
      (row) =>
        (row.revisionType === 'INCREMENT' || row.revisionType === 'PROMOTION') && row.effectiveFrom <= today,
    ) ?? null
  );
}
